import { render, staticRenderFns } from "./gazyjsxy.vue?vue&type=template&id=87627f92&scoped=true&"
import script from "./gazyjsxy.vue?vue&type=script&lang=js&"
export * from "./gazyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./gazyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./gazyjsxy.vue?vue&type=style&index=1&id=87627f92&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87627f92",
  null
  
)

export default component.exports